/**
 * The two number formats the admin UI ships: English (`22,567.5`) and European
 * (`22 567,5`), the latter borrowed from `nb`. Nothing here is derived from the
 * chosen UI language — Norwegian is not one of the five UI languages, so a
 * Norwegian user's separators can only come from their browser or system setup.
 */
export type AppLocale = 'en' | 'nb';

/**
 * Formatting locale for every number and date in the app. `LOCALE_ID` is provided
 * from this, so the `number` pipe follows it; the few non-DI call sites (ag-grid
 * value formatters) call it directly to stay in step.
 */
export function resolveAppLocale(): AppLocale {
  const browserLocale =
    globalThis.navigator?.languages?.[0]?.toLowerCase() ??
    globalThis.navigator?.language?.toLowerCase();

  return browserLocale?.startsWith('en') ? 'en' : 'nb';
}
